export default "__VITE_ASSET__DJOwobj0__"